import { createActions, createReducer } from 'reduxsauce'

const situacoes = [
    { value: null, label: 'Todas' },
    { value: 'A', label: 'Aprovada' },
    { value: 'F', label: 'Fechada' },
    { value: 'I', label: 'Incluída' },
    { value: 'L', label: 'Liberada' },
    { value: 'P', label: 'Paga' },
]

/**
 * Action types & creators
 */

export const { Types, Creators } = createActions({
    setExercicioConsultaOrdensPagamentosExtraorcamentarias: ['exercicio'],
    setDataOrdemInicialConsultaOrdensPagamentosExtraorcamentarias: ['dataOrdemInicial'],
    setDataOrdemFinalConsultaOrdensPagamentosExtraorcamentarias: ['dataOrdemFinal'],
    setDataPagamentoInicialConsultaOrdensPagamentosExtraorcamentarias: ['dataPagamentoInicial'],
    setDataPagamentoFinalConsultaOrdensPagamentosExtraorcamentarias: ['dataPagamentoFinal'],
    setAdministracaoConsultaOrdensPagamentosExtraorcamentarias: ['administracao'],
    setSituacaoConsultaOrdensPagamentosExtraorcamentarias: ['situacao'],
    setRecursoConsultaOrdensPagamentosExtraorcamentarias: ['recurso'],
    setDestinacaoConsultaOrdensPagamentosExtraorcamentarias: ['destinacao'],
    setNomeCredorConsultaOrdensPagamentosExtraorcamentarias: ['nomeCredor'],
    setCnpjConsultaOrdensPagamentosExtraorcamentarias: ['cnpj'],
    setCpfConsultaOrdensPagamentosExtraorcamentarias: ['cpf'],
    limpaFiltroConsultaOrdensPagamentosExtraorcamentarias: [],
    receberFiltroConsultaOrdensPagamentosExtraorcamentarias: ['filtroRecebido'],
})

const INITIAL_STATE = {
    exercicio: { value: new Date().getFullYear(), label: new Date().getFullYear() },
    dataOrdemInicial: '',
    dataOrdemFinal: '',
    dataPagamentoInicial: '',
    dataPagamentoFinal: '',
    administracao: null,
    destinacao: null,
    situacao: { value: situacoes[0].value, label: situacoes[0].label },
    nomeCredor: '',
    cnpj: '',
    cpf: '',
    recurso: null,
}

const setExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: action.exercicio }
}
const setDataOrdemInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataOrdemInicial: action.dataOrdemInicial }
}
const setDataOrdemFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataOrdemFinal: action.dataOrdemFinal }
}
const setDataPagamentoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataPagamentoInicial: action.dataPagamentoInicial }
}
const setDataPagamentoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataPagamentoFinal: action.dataPagamentoFinal }
}
const setAdministracao = (state = INITIAL_STATE, action) => {
    return { ...state, administracao: action.administracao }
}
const setSituacao = (state = INITIAL_STATE, action) => {
    return { ...state, situacao: action.situacao }
}
const setRecurso = (state = INITIAL_STATE, action) => {
    return { ...state, recurso: action.recurso }
}
const setDestinacao = (state = INITIAL_STATE, action) => {
    return { ...state, destinacao: action.destinacao }
}
const setNomeCredor = (state = INITIAL_STATE, action) => {
    return { ...state, nomeCredor: action.nomeCredor }
}
const setCnpj = (state = INITIAL_STATE, action) => {
    return { ...state, cnpj: action.cnpj }
}
const setCpf = (state = INITIAL_STATE, action) => {
    return { ...state, cpf: action.cpf }
}
const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}
const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_EXERCICIO_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS]: setExercicio,
    [Types.SET_DATA_ORDEM_INICIAL_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS]: setDataOrdemInicial,
    [Types.SET_DATA_ORDEM_FINAL_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS]: setDataOrdemFinal,
    [Types.SET_DATA_PAGAMENTO_INICIAL_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS]: setDataPagamentoInicial,
    [Types.SET_DATA_PAGAMENTO_FINAL_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS]: setDataPagamentoFinal,
    [Types.SET_ADMINISTRACAO_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS]: setAdministracao,
    [Types.SET_SITUACAO_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS]: setSituacao,
    [Types.SET_RECURSO_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS]: setRecurso,
    [Types.SET_DESTINACAO_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS]: setDestinacao,
    [Types.SET_NOME_CREDOR_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS]: setNomeCredor,
    [Types.SET_CNPJ_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS]: setCnpj,
    [Types.SET_CPF_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS]: setCpf,
    [Types.LIMPA_FILTRO_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS]: receberFiltro,
})
